import { Field, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from '@gn-audio/jss-components/lib/component-props';

export type StatsSpotFields = {
  backgroundColor: Field<string>;
  eyebrowText: Field<string>;
  headline: Field<string>;
  description: Field<string>;
  stats: StatProps[];
  footerText: Field<string>;
  ctaButtonLink: LinkField;
  ctaButtonLabel: Field<string>;
  disclaimers: DisclaimerProps[];
};

export type StatProps = {
  id?: string;
  value: Field<string>;
  valueFontColor: Field<string>;
  description: Field<string>;
};

export type DisclaimerProps = {
  id?: string;
  text: Field<string>;
};

export type StatsSpotProps = {
  fields: StatsSpotFields;
} & ComponentProps;
